<template>
  <div>
    <h4>{{ order.client.phone }}</h4>

    <a :href="link" @click="back" target="_blank" class="btn btn-info">{{
      "no_working" | setText("Открыть новое окно")
    }}</a>

    <div class="install-control">
      <iframe
        ref="iframe"
        allow="camera; microphone"
        :src="link"
        frameBorder="0"
        class="iframe"
        @load="resizeIframe"
      />
    </div>
  </div>
</template>
<script>
import { logger } from "../../../plugins/functions";

export default {
  computed: {
    link() {
      return `${this.hash}&callback=${this.$store.state.host}/api/redirect/order/${this.order.id}/${this.partner.id}&companyId=${this.partner.api_public_key}`;
    },
  },
  mounted() {
    try {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        // Запрашиваем доступ к устройству захвата
        navigator.mediaDevices
          .getUserMedia({ video: true, audio: true })
          .then((stream) => {
            // Получаем ссылку на элемент video
            const videoElement = this.$refs.iframe;
            // Устанавливаем полученный поток как источник видео
            videoElement.srcObject = stream;
          })
          .catch((error) => {
            alert("Ошибка. На устройстве не обнаружена камера");
          });
      } else {
      }
    } catch (error) {}
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    index: {
      default: 0,
    },
    hash: {
      default: "",
    },
  },
  name: "filter",
  async created() {
    this.$loading(true);
  },
  methods: {
    back() {
      setTimeout(() => {
        this.$emit("next", 0);
      }, 10);
    },
    next() {
      this.save();
    },
    save() {
      this.$loading(true);
      logger(this.$http, {
        name: "Добавление пользователя в #PAYMART",
        description: "Начало запроса",
        model_type: "order",
        model_id: this.order.id,
      });
    },
    resizeIframe() {
      this.$loading(false);
    },
  },
  data() {
    return {
      message: "",
      result: null,
      buyer_id: null,
    };
  },
};
</script>